import React, { useLayoutEffect, useRef, useState } from "react";
import "./_qokr-mode-toggle.scss";

// ═══════════════════════════════════════════════════════════════════════════
// The review screens' mode switch — Strategy Canvas's "Review Mode | Canvas
// Mode" and the Execution Blueprint's "Review Mode | Blueprint Mode", for
// Quarterly OKRs: "Review Mode | Alignment Mode". Same grey track and white
// active tab, plus a sliding thumb that moves between them.
//
// `options`: [{ key, label, icon? }] · `value` · `onChange(key)`.
// Shared, byte-identical, by the CEO app and the coach app.
// ═══════════════════════════════════════════════════════════════════════════

const QokrModeToggle = ({
  options = [],
  value,
  onChange,
  ariaLabel = "View",
}) => {
  const trackRef = useRef(null);
  const [thumb, setThumb] = useState(null);

  useLayoutEffect(() => {
    const track = trackRef.current;
    const active = track?.querySelector("[data-active='true']");
    if (!active) return;
    setThumb({ left: active.offsetLeft, width: active.offsetWidth });
  }, [value, options.length]);

  return (
    <div
      className="qokr-mode-toggle"
      role="tablist"
      aria-label={ariaLabel}
      ref={trackRef}
    >
      {thumb ? (
        <span
          className="qokr-mode-toggle__thumb"
          style={{
            transform: `translateX(${thumb.left}px)`,
            width: thumb.width,
          }}
          aria-hidden="true"
        />
      ) : null}
      {options.map((option) => {
        const active = option.key === value;
        return (
          <button
            key={option.key}
            type="button"
            role="tab"
            aria-selected={active}
            data-active={active ? "true" : "false"}
            className={`qokr-mode-toggle__btn${active ? " is-active" : ""}`}
            onClick={() => !active && onChange?.(option.key)}
          >
            {option.icon ? (
              <i className={option.icon} aria-hidden="true" />
            ) : null}
            {option.label}
          </button>
        );
      })}
    </div>
  );
};

export default QokrModeToggle;
